export default {
  api: "https://preprod.api.euresto.com/",
  "socketTransport": ["polling", "websocket"]
}
